
import { Component, Mixins } from 'vue-property-decorator';
import moment from 'moment';
import EditConnectionDialogMixin from '@/mixins/EditConnectionDialogMixin.vue';
import IterMixin from '@/mixins/IterMixin.vue';
import { Iter, IterType } from '@/types';

moment.locale('it');

@Component
export default class EditIterAcceptanceDialog extends Mixins(EditConnectionDialogMixin, IterMixin) {
  iter: Iter | null = null
  iterType: IterType | null = null
  iterAcceptance = false
  iterAcceptanceDate: Date | null = null

  // Aggiorna i campi con gli eventuali nuovi valori della Connection/Lead selezionata
  refresh() {
    console.log(`${this.constructor.name}: refresh()`); // eslint-disable-line no-console

    // Aggiorna i campi con i valori della Connection
    this.iter = this.connection?.iter ?? null;
    this.iterType = this.connection?.iterType ?? null;
    this.iterAcceptance = this.connection?.iterAcceptance ?? false;
    this.iterAcceptanceDate = this.connection?.iterAcceptanceDate ?? null;

    // Richiama il metodo del mixin
    return this.mixinRefresh();
  }

  onFieldUpdated(field: string) {
    console.log(`${this.constructor.name}: onFieldUpdated(${field})`); // eslint-disable-line no-console

    // Modifico eventuali campi collegati
    const update = {} as { [key: string]: unknown };
    switch (field) {
      case 'iter':
        // Se è stato modificato l'iter, resetto la sua accettazione
        this.iterAcceptance = false;
        update.iterAcceptance = false;
        this.iterAcceptanceDate = null;
        update.iterAcceptanceDate = null;
        break;

      case 'iterType':
        // Se è stato deselezionato il tipo di iter, resetto la sua accettazione
        if (!this.iterType) {
          this.iterAcceptance = false;
          update.iterAcceptance = false;
          this.iterAcceptanceDate = null;
          update.iterAcceptanceDate = null;
        }
        break;

      default:
        break;
    }
    this.$store.dispatch('updateConnectionFields', {
      fields: update,
    });

    // Richiama il metodo del mixin
    return this.mixinOnFieldUpdated(field);
  }

  // Aggiorna eventuali campi collegati allo switch poi chiama il metodo del mixin
  onSwitchChange(name: string) {
    console.log(`${this.constructor.name}: onSwitchChange(${name})`); // eslint-disable-line no-console

    // Modifico eventuali campi collegati
    const update = {} as { [key: string]: unknown };
    switch (name) {
      case 'iterAcceptance':
        if (this.iterAcceptance) {
          this.iterAcceptanceDate = moment(moment(), 'YYYY-MM-DD').toDate();
          update.iterAcceptanceDate = this.iterAcceptanceDate;
        } else {
          this.iterAcceptanceDate = null;
          update.iterAcceptanceDate = null;
        }
        break;

      default:
        break;
    }
    this.$store.dispatch('updateConnectionFields', {
      fields: update,
    });

    // Richiama il metodo del mixin
    return this.mixinOnSwitchChange(name);
  }
}
